function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-1592973403876155522",
  d: "M10,0c-5.51082,0 -10,4.48918 -10,10c0,5.51082 4.48918,10 10,10c5.51082,0 10,-4.48918 10,-10c0,-5.51082 -4.48918,-10 -10,-10zM10,1.53846c4.68149,0 8.46154,3.78005 8.46154,8.46154c0,4.68149 -3.78005,8.46154 -8.46154,8.46154c-4.68149,0 -8.46154,-3.78005 -8.46154,-8.46154c0,-4.68149 3.78005,-8.46154 8.46154,-8.46154z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgUnChecked = function SvgUnChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(0, 90, 131)"
    },
    d: "M10,0c-5.51082,0 -10,4.48918 -10,10c0,5.51082 4.48918,10 10,10c5.51082,0 10,-4.48918 10,-10c0,-5.51082 -4.48918,-10 -10,-10zM10,1.53846c4.68149,0 8.46154,3.78005 8.46154,8.46154c0,4.68149 -3.78005,8.46154 -8.46154,8.46154c-4.68149,0 -8.46154,-3.78005 -8.46154,-8.46154c0,-4.68149 3.78005,-8.46154 8.46154,-8.46154z",
    vectorEffect: "non-scaling-stroke"
  })), _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/un-checked.ff6b2172.svg";
export { ForwardRef as ReactComponent };